import React, {useEffect} from 'react';

import {Form, Input, Button, Radio, Upload, Checkbox, Row, Col, Typography, Select, DatePicker, Divider, Alert, InputNumber, Card, message} from 'antd';
import Flex from '../Flex';
const {Text, Title, Paragraph} = Typography;

import {useInput, useNumber} from 'react-hanger';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {AuthorizeApi, UserApi} from '../../scaffold';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import useAuth from '../../utils/AuthContext';

const UpdatePasswordForm = (props: {userId: number; onSuccess: () => any}) => {
  const updateState = useOpenApiFpRequest(UserApi, UserApi.prototype.userUpdatePasswordPost);
  const username = useInput('');
  const password = useInput('');
  const auth = useAuth();
  function update() {
    updateState
      .request({
        userUpdatePasswordModel: {
          id: props.userId,
          password: password.value,
        },
      })
      .then(res => {
        message.success('修改成功');
        props.onSuccess();
      })
      .catch(CommonApiErrorHandler);
  }

  return (
    <Form labelCol={{span: 6}} wrapperCol={{span: 14}} layout={'horizontal'}>
      <Form.Item label={'密码'} name={'password'} required>
        <Input.Password size={'large'} placeholder="请输入密码" {...password.eventBind} />
      </Form.Item>
      <Row>
        <Col span={6} />
        <Col>
          <Button size={'large'} type="primary" loading={updateState.loading} onClick={update}>
            确定修改
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default UpdatePasswordForm;
